export const ssnFourDigits = {
  default: [/\d/, /\d/, /\d/, /\d/]
};
